import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './navigationButtons.scss';
import NavigationActions from '../../redux/navigationRedux';

const NavigationButtonsView = (
    {
        navigateForward,
        navigateBackward,
        navigation,
        loading,
        model,
    }) => {
    const { forwardNavigation, backwardNavigation } = navigation;
    let nextStepButton = null;
    let nextButtonStyle = style.nextButton;
    let backButtonStyle = style.backButton;
    let navigationPossible = true;

    if (loading || model === null) {
        nextButtonStyle = style.disabledNextButton;
        backButtonStyle = style.disabledBackButton;
        navigationPossible = false;
    }

    if (forwardNavigation) {
        nextStepButton = (
            <button
                className={nextButtonStyle}
                onClick={navigationPossible ? () => navigateForward() : null}
                disabled={!forwardNavigation}
            >
                <div className={style.nextIcon} />
                <span>{t`Weiter`}</span>
            </button>
        );
    }
    return (
        <div className={style.container}>
            <button
                className={backButtonStyle}
                onClick={navigationPossible ? () => navigateBackward() : null}
                disabled={!backwardNavigation}
            >
                <div className={style.backIcon} />
                <span>{t`Zurück`}</span>
            </button>
            {nextStepButton}
        </div>
    );
};

const mapStateToProps = state => ({
    activeStep: state.navigation.active,
    stepList: state.navigation.items,
    navigation: state.navigation,
    loading: state.parts.fetching,
    model: state.configuration.model,
});

const mapDispatchToProps = dispatch => ({
    navigateForward: () => dispatch(NavigationActions.navigateForward()),
    navigateBackward: () => dispatch(NavigationActions.navigateBackward()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationButtonsView);
